var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyQuestionBoolean } from "./boolean";
var SurveyQuestionBooleanRadio = /** @class */ (function (_super) {
    __extends(SurveyQuestionBooleanRadio, _super);
    function SurveyQuestionBooleanRadio(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionBooleanRadio.prototype.renderRadioItem = function (value, locText) {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        var handleOnChange = function () {
            _this.question.value = value;
        };
        return (React.createElement("div", { role: "presentation", className: this.question.getRadioItemClass(cssClasses, value) },
            React.createElement("label", { className: cssClasses.radioLabel },
                React.createElement("input", { type: "radio", name: this.question.name, value: value, "aria-errormessage": this.question.ariaErrormessage, checked: value === this.question.value, disabled: this.question.isDisabledAttr, readOnly: this.question.isReadOnlyAttr, className: cssClasses.itemRadioControl, onChange: handleOnChange }),
                this.question.cssClasses.materialRadioDecorator ?
                    (React.createElement("span", { className: cssClasses.materialRadioDecorator }, this.question.itemSvgIcon ?
                        (React.createElement("svg", { className: cssClasses.itemRadioDecorator },
                            React.createElement("use", { xlinkHref: this.question.itemSvgIcon }))) : null)) : null,
                React.createElement("span", { className: cssClasses.radioControlLabel }, this.renderLocString(locText)))));
    };
    SurveyQuestionBooleanRadio.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        return (React.createElement("div", { className: cssClasses.rootRadio },
            React.createElement("fieldset", { role: "presentation", className: cssClasses.radioFieldset }, !this.question.swapOrder ?
                (React.createElement(React.Fragment, null,
                    this.renderRadioItem(this.question.getValueFalse(), this.question.locLabelFalse),
                    this.renderRadioItem(this.question.getValueTrue(), this.question.locLabelTrue)))
                :
                    (React.createElement(React.Fragment, null,
                        this.renderRadioItem(this.question.getValueTrue(), this.question.locLabelTrue),
                        this.renderRadioItem(this.question.getValueFalse(), this.question.locLabelFalse))))));
    };
    return SurveyQuestionBooleanRadio;
}(SurveyQuestionBoolean));
export { SurveyQuestionBooleanRadio };
ReactQuestionFactory.Instance.registerQuestion("sv-boolean-radio", function (props) {
    return React.createElement(SurveyQuestionBooleanRadio, props);
});
RendererFactory.Instance.registerRenderer("boolean", "radio", "sv-boolean-radio");
